import { IS_ACTIVE } from "../_defs";

const ATTR_NAME = "data-in-view";
const SCALE = 100;
const DURATION_MS = 500;

ScrollTrigger.config({
  // autoRefreshEvents: "resize,load,visibilitychange,DOMContentLoaded"
  autoRefreshEvents: "resize,visibilitychange"
});

const inView = (e: HTMLElement, x: number, y: number): void => {
  let enabled = false;

  const animation = gsap
    .fromTo(
      e,
      {
        opacity: 0,
        x: `${x * SCALE}px`,
        y: `${y * SCALE}px`
      },
      {
        duration: DURATION_MS / 1000,
        opacity: 1,
        x: 0,
        y: 0,
        onComplete() {
          e.classList.add(IS_ACTIVE);
        }
      }
    )
    .pause();

  ScrollTrigger.create({
    trigger: e,
    start: `${-y * SCALE}px 90%`,
    end: `bottom-=${y * SCALE}px 0%`,
    toggleActions: "play reset play reset",
    onEnter() {
      if (enabled) {
        animation.resume();
        enabled = false;
      }
    },
    onEnterBack() {
      if (enabled) {
        animation.resume();
        enabled = false;
      }
    },
    onToggle() {
      enabled = true;
    }
  });
};

export const setupInView = (): void => {
  document.querySelectorAll<HTMLElement>(`[${ATTR_NAME}]`).forEach((e) => {
    switch (e.getAttribute(ATTR_NAME)) {
      case "slide-45":
        inView(e, -1, -1);
        break;

      case "slide-135":
        inView(e, 1, -1);
        break;

      case "slide-225":
        inView(e, 1, 1);
        break;

      case "slide-down":
        inView(e, 0, -1);
        break;

      case "slide-right":
        inView(e, -1, 0);
        break;

      case "slide-left":
        inView(e, 1, 0);
        break;

      default:
        inView(e, 0, 1);
        break;
    }
  });
};
